import { map } from "lodash";

export const toQueryParams = values =>
  map(
    values,
    (value, key) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  ).join("&");
